export const AUTHENTICATION = "AUTHENTICATION";
export const USER_INFO = "USER_INFO";
export const PDF_DATA = "PDF_DATA";

export const ADMIN = "admin";
